import AccordionMui from '@mui/material/Accordion';
import Typography from '@mui/material/Typography';
import { AccordionSummaryCompetitor } from './AccordionSummaryCompetitor';
import { Link } from 'src/components/Link';
import { useCompetitor } from './AccordionCompetitor';

export const AccordionCompetitorSolo: React.FC = () => {
  const { participants } = useCompetitor();

  return (
    <AccordionMui
      disableGutters
      sx={{
        '& .MuiAccordionSummary-root': {
          pointerEvents: 'none',
        },
      }}
    >
      <Link
        href={`/profile/${participants[0].userId}`}
        sx={{
          textDecoration: 'inherit',
          color: 'inherit',
        }}
      >
        <AccordionSummaryCompetitor
          LeftChildren={
            <Typography
              variant="overline"
              color="text.secondary"
              sx={{ alignSelf: 'center' }}
            >
              SOLO
            </Typography>
          }
        />
      </Link>
    </AccordionMui>
  );
};
